import axios from "axios";
import { getSessionId } from "./session";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const UTM_KEY = "ea_first_utm";

export function captureUtmFirstTouch() {
    try {
        const existing = localStorage.getItem(UTM_KEY);
        if (existing) return JSON.parse(existing);
        const p = new URLSearchParams(window.location.search);
        const utm = {};
        ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(k => {
            if (p.get(k)) utm[k] = p.get(k);
        });
        if (p.get("ref")) utm.ref = p.get("ref");
        if (!utm.utm_source && document.referrer) {
            try { utm.referrer = new URL(document.referrer).hostname; } catch { /* ignore */ }
        }
        localStorage.setItem(UTM_KEY, JSON.stringify(utm));
        return utm;
    } catch {
        return {};
    }
}

export function track(event, props = {}) {
    try {
        axios.post(`${BACKEND_URL}/api/events`, {
            session_id: getSessionId(),
            event,
            props,
            utm: captureUtmFirstTouch(),
        }).catch(() => {});
    } catch { /* never block UX on analytics */ }
}

export function trackOnce(event, props = {}) {
    const key = `ea_evt_${event}_${getSessionId()}`;
    try {
        if (localStorage.getItem(key)) return;
        localStorage.setItem(key, "1");
    } catch { /* ignore */ }
    track(event, props);
}
